import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Loader from './Loader';

const ProtectedRoute = ({ children }) => {
   const { isAuthenticated, loading } = useAuth();

   if (loading) {
      return (
         <div className="flex min-h-screen items-center justify-center">
            <Loader size="lg" />
         </div>
      );
   }

   if (!isAuthenticated) {
      return <Navigate to="/login" replace />;
   }

   return children;
};

export default ProtectedRoute;
